'use client'
import React, { useState } from 'react'
import Image from 'next/image'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import LinkComponent from './LinkComponent';
import { Dialog } from '@headlessui/react'
import { IoLogoWhatsapp } from "react-icons/io";
import { IoClose } from "react-icons/io5";
import { FaLine, FaPhoneSquareAlt } from 'react-icons/fa'
import QRCodeGenerator from '@components/QRCodeGenerator'
import { company } from '@constants/company'
import tailwindConfig from '@tailwind.config'
import Link from 'next/link';

const PromotedProjectModule = ({ item, dictionary, lang }) => {

    const [waQrIsOpen, setWaQrIsOpen] = useState(false)  
    const [lineQrIsOpen, setLineQrIsOpen] = useState(false)  
    const [isCopied, setIsCopied] = useState(false);

    const [gallerySlider, setGallerySlider] = useState(true)

  return (
        <div className='w-full mx-auto flex sm:flex-row flex-col py-6 px-3'>
            <div className='w-full sm:w-1/2 relative  overflow-hidden shadow-sm rounded-xs'>
                {/* <div className='overflow-hidden w-full h-full'>
                    <Image 
                        src={'/images/listwithus2.jpg'}
                        
                        width={1252}
                        height={646}
                        // className='object-none'
                        className="inset-0 h-full object-cover w-full aspect-[4/3]"
                    />
                </div> */}
                <div className='relative w-full  aspect-[4/3] rounded-t-xs overflow-hidden'>
                    <div className='absolute z-[80] flex flex-col top-1 left-1 p-2 bg-third text-white font-bold'>{item?.promotionTitle}</div>
                    <div className='absolute z-[80] w-[300px] flex flex-col bottom-0 left-0 p-2 bg-label'>
                        <span className='text-white font-bold text-xl'>{item?.name}</span>
                        <span className='text-white'>{dictionary?.property?.newDevelopment}</span>
                    </div>
                    {gallerySlider == true ? (
                        <Swiper
                            slidesPerView={1}
                            pagination={{
                                clickable: true,
                            }}
                            navigation={true}
                            modules={[Navigation]}
                            className='w-full h-full new'
                        >
                            {item?.gallery?.map((image, index) => (
                                <SwiperSlide key={index} className='new'>
                                    <Image
                                        // placeholder="blur"
                                        // blurDataURL={property.blur}
                                        // className='object-fit'
                                        className='object-cover'
                                        src={image}
                                        // width={imageWidth}
                                        // height={imageHeight}
                                        fill={true}
                                        // alt={property.slug}
                                    />
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    ) : (
                        <Image
                            // placeholder="blur"
                            // blurDataURL={property.blur}
                            // className='object-fit'
                            className='object-cover'
                            src={item?.gallery?.[0]}
                            // width={imageWidth}
                            // height={imageHeight}
                            fill={true}
                            // alt={property.slug}
                        />
                    )}
                </div>
            </div>
            <div className='sm:w-1/2 w-full text-white flex flex-col justify-center items-start border-none px-3 sm:px-0 sm:border-l-[1px]'>
                <div className='w-full px-0 sm:px-10 sm:mt-0 mt-3'>
                    <div className='mb-6 text-2xl'>
                        <p className='text-white font-semibold mb-1'>EXCLUSIVE New Development by</p>
                        <p className='text-white font-semibold mb-1'>Property Pros Pattaya</p>
                    </div>
                    <div className='mb-6'>
                        <div className='text-2xl'>{dictionary?.property?.projectName}: {item?.name}</div>
                        <div className='text-2xl'>{dictionary?.property?.location}: {item?.districts?.[0]?.subdistrictName[lang]}</div>

                        <div className='text-2xl'>{dictionary?.property?.startingPrice}: {item?.startingPrice}</div>
                        <div className='mt-6 text-xl italic'>"The ultimate privacy near Regent-Rugby International School"</div>
                    </div>
                    <div className='w-full flex flex-col'>
                        <div className='mb-2'>{dictionary?.property?.details}:</div>
                        <div className='w-full flex flex-row gap-2'>
                            {item?.units && item?.units !== '' && (
                                <div className='w-1/2 flex flex-col bg-white rounded-xs px-4 py-2'>
                                    <span className='text-maincolor font-semibold text-xl'>{item?.units}</span>
                                    <span className='text-label'>{dictionary?.property?.units}</span>
                                </div>
                            )}
                            {item?.towers && item?.towers !== '' && (
                                <div className='w-1/2 flex flex-col bg-white rounded-xs px-4 py-2'>
                                    <span className='text-maincolor font-semibold text-xl'>{item?.towers}</span>
                                    <span className='text-label'>{dictionary?.property?.towers}</span>
                                </div>
                            )}
                            {item?.floors && item?.floors !== '' && (
                                <div className='w-1/2 flex flex-col bg-white rounded-xs px-4 py-2'>
                                    <span className='text-maincolor font-semibold text-xl'>{item?.floors}</span>
                                    <span className='text-label'>{dictionary?.property?.floors}</span>
                                </div>
                            )}
                            {item?.yearBuilt && item?.yearBuilt !== '' && (
                                <div className='w-1/2 flex flex-col bg-white rounded-xs px-4 py-2'>
                                    <span className='text-maincolor font-semibold text-xl'>{item?.yearBuilt}</span>
                                    <span className='text-label'>{dictionary?.property?.yearBuilt}</span>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className='mt-6 w-full flex sm:flex-row flex-col justify-center gap-1'>
                        <div className='sm:w-1/2 w-full'>
                            <LinkComponent href={`/new-developments/${item?.slug}`} className='w-full flex items-center justify-center bg-third font-semibold rounded-xs py-2'>{dictionary?.property?.seeFullDetails}</LinkComponent>
                        </div>
                        <div className='sm:w-1/2 w-full gap-1 flex flex-row'>
                            {company.whatsappUrl && (
                                <button onClick={() => {setWaQrIsOpen(true)}} title='WhatsApp' href={`${company.whatsappUrl}`} className='w-1/2 flex flex-row justify-center bg-gradient-to-r from-[#25D366] to-[#25de68] hover:from-[#25de68] hover:to-[#25D366] py-1 px-1 items-center rounded-xs shadow-sm drop-shadow-md' >
                                    <IoLogoWhatsapp
                                        color={tailwindConfig.theme.extend.colors.light}
                                        size={24}
                                        className=''
                                    />
                                    <span className='text-center text-light font-semibold ml-2'>Whatsapp</span>
                                </button>
                            )}
                            {company.lineUrl && (
                                <button onClick={() => {setLineQrIsOpen(true)}} title='LINE' href={company.lineUrl} className='w-1/2 flex flex-row justify-center inset-0  bg-gradient-to-r from-[#32CD32] to-[#2dbc2d] transition-colors hover:from-[#2dbc2d] hover:to-[#32CD32] py-2 px-1 items-center rounded-xs shadow-sm drop-shadow-md' target="_blank">
                                    <FaLine
                                        color={tailwindConfig.theme.extend.colors.light}
                                        size={24}
                                        className=''
                                    />
                                    <span className='text-center text-light font-semibold ml-2'>LINE</span>
                                </button>
                            )}
                        </div>
                        <Dialog
                            open={waQrIsOpen}
                            onClose={() => setWaQrIsOpen(false)}
                            className="relative z-50"
                        >
                            <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
                            <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
                                <Dialog.Panel className="mx-auto max-w-sm rounded bg-white p-4">
                                    <Dialog.Title>
                                        <div className='flex flex-row justify-between items-center'>

                                            <button title='Close QR Modal' className='bg-third hover:bg-[#b81435] duration-200 flex items-center justify-center rounded-xs w-[30px] h-[30px]' onClick={() => {setWaQrIsOpen(false)}}>
                                                <IoClose 
                                                    size={16}
                                                    color={tailwindConfig.theme.extend.colors.light}
                                                />
                                            </button>
                                        </div>
                                    </Dialog.Title>
                                    <div className='flex flex-col items-center'>
                                        <QRCodeGenerator dictionary={dictionary} url={`${company.whatsappUrl}`} />
                                        <div className='w-full flex flex-row justify-center items-center'>
                                            <Link className='w-full bg-[#25D366] text-maincolor p-2 rounded-xs text-center' href={company.whatsappUrl}>{dictionary?.contactCard?.openInWhatsapp}</Link>
                                        </div>
                                    </div>
                                </Dialog.Panel>
                            </div>
                        </Dialog>
                        <Dialog
                            open={lineQrIsOpen}
                            onClose={() => setLineQrIsOpen(false)}
                            className="relative z-50"
                        >
                            <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
                            <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
                                <Dialog.Panel className="mx-auto max-w-sm rounded bg-white p-4">
                                    <Dialog.Title>
                                        <div className='flex flex-row justify-between items-center'>
                                            <button title='Close QR Modal' className='bg-third hover:bg-[#b81435] duration-200 flex items-center justify-center rounded-xs w-[30px] h-[30px]' onClick={() => {setLineQrIsOpen(false)}}>
                                                <IoClose 
                                                    size={16}
                                                    color={tailwindConfig.theme.extend.colors.light}
                                                />
                                            </button>
                                        </div>
                                    </Dialog.Title>
                                    <div className='flex flex-col items-center'>
                                        <QRCodeGenerator dictionary={dictionary} url={`${company.lineUrl}`} />
                                    </div>
                                </Dialog.Panel>
                            </div>
                        </Dialog>
                    </div>
                </div>
            </div>
        </div>
  )
}

export default PromotedProjectModule